





import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class SimpleSelect extends Vue {
  @Prop({ default: [] })
  options!: { value: string; title: string }[];

  @Prop({ default: '' })
  value!: string; //データのデフォルト値（オプションのvalueの1つを記入）

  @Prop({ default: '' })
  private css_class!: any;

  @Prop({ default: 1 })
  private size!: number;

  get model() {
    const found = this.options.find((i) => i.value == this.value);
    if (!found) {
      return '';
    }
    return found.value;
  }

  set model(value: string) {
    this.$emit('input', value);
  }

  created() {
    // console.log('ssl', this.options);
  }
}
